var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkipForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14C2.3674 14 2.24022 13.9474 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V2.50003C1.99965 2.41193 2.02259 2.3253 2.06649 2.24891C2.11039 2.17252 2.1737 2.10909 2.25 2.06503C2.32601 2.02115 2.41224 1.99805 2.5 1.99805C2.58777 1.99805 2.67399 2.02115 2.75 2.06503L12.25 7.56503C12.327 7.60864 12.391 7.67188 12.4355 7.7483C12.48 7.82472 12.5035 7.91159 12.5035 8.00003C12.5035 8.08848 12.48 8.17535 12.4355 8.25177C12.391 8.32819 12.327 8.39143 12.25 8.43503L2.75 13.935C2.6738 13.9782 2.58759 14.0006 2.5 14ZM3 3.36503V12.635L11 8.00003L3 3.36503ZM14 2.00003H15V14H14V2.00003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForward);
export default __webpack_public_path__ + "static/media/skip-forward.485a5cdead7d76192cb82203dab671da.svg";
export { ForwardRef as ReactComponent };